import React, { useEffect, useState, ChangeEvent, useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { getOrderNetCollected, orderHasCollectedPayments } from "helpers/orderFinancial";
import { refundOrderPayments } from "helpers/refundOrderPayments";
import { useStripeTerminalPayment } from "hooks/useStripeTerminalPayment/useStripeTerminalPayment";
import {
  displayPercent,
  customerErrorMessage,
  printDesktopReceipt,
  valueToString,
  errorMessage,
  displayCurrency,
} from "helpers/Helpers";
import moment, { MomentInput } from "moment";

import {
  GetOrder,
  PutVoidOrder,
  PutReinstateOrder,
  PutOrder,
  PutOrderTip,
  PutOrderTipAllocations,
  GetReceipt,
  EmailReceipt,
  GetOrderAudits,
  GetERangePins,
  IERangePin,
  PrintERangePins,
  PutERangePinRegenerate,
} from "api/rpc/2024-04/facilityAdmin/order/order";

import {
  GetGiftCard,
  PrintGiftCard,
  DownloadGiftCard,
  IGiftCard,
} from "api/rpc/2024-04/facilityAdmin/payment/giftCard";

import { StatusCode } from "api/protocols";

import { IOrder, IOrderLineItem, IOrderTransaction } from "redux/reducers/models/order";
import OrderLineItemBlock from "pages/secure/facility/order/OrderLineItemBlock";
import OrderExchangeCard from "pages/secure/facility/order/OrderExchangeCard";
import OrderTenderRows from "pages/secure/facility/order/OrderTenderRows";
import {
  aggregateLineItemTaxLines,
  attachLineItemModifiers,
  lineItemMerchandiseTotal,
  originalTenders,
  replacementLineItemIds,
} from "pages/secure/facility/order/orderExchangeDisplay";

import "pages/secure/facility/order/order.scss";
import Page from "components/page/Page";
import Card from "components/card/Card";
import { Badge } from "components/badge/Badge";
import Input from "components/form/input/Input";
import { LocaleCurrency } from "helpers/Locale";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";

import {
  faCircleCheck as faCircleCheckRegular,
  faChevronDown,
  faBan,
  faCircleExclamation,
  faRotateLeft,
  faCircleQuestion,
} from "@fortawesome/pro-regular-svg-icons";
import Sheet from "components/sheet/Sheet";
import FormLayout from "components/form/FormLayout";
import { ButtonNew as Button } from "components/buttonNew/index";
import { Select } from "components/select/index";
import { ICustomer } from "redux/reducers/models/customer";
import { GetCustomer, PostCustomer } from "api/rpc/2024-04/facilityAdmin/customer/customer";
//import order from "containers/facility/order";
import { dequeue, enqueue, IUIActions, showError } from "redux/actions/ui";
import ReactDOM from "react-dom";
import { IAuthState } from "redux/reducers/auth";
import { useTranslation } from "react-i18next";
import { ICustomerInfoState } from "components/newCustomer/NewCustomer";
import DatePickerInput from "components/datePickerInput/DatePickerInput";
import { PutTransaction } from "api/rpc/2024-04/facilityAdmin/order/transaction";
import TextField from "components/form/textField/TextField";
import classNames from "classnames";
import Popup from "components/popup/Popup";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import Checkbox from "components/form/checkbox/Checkbox";
import { IForm } from "api/rpc/2024-04/guest/form";
import TimePick from "components/timePick/TimePick";
import ChangeCustomer from "components/changeCustomer/ChangeCustomer";
import MoveHouseAccountPaymentsSheet, {
  HouseAccountMoveChoice,
} from "components/changeCustomer/MoveHouseAccountPaymentsSheet";
import { GetAccount } from "api/rpc/2024-04/facilityAdmin/client/accounts";
import { orderHasActiveHouseAccountPayments } from "helpers/orderHouseAccountPayments";
import { HouseAccountType } from "pages/secure/facility/customer/context/contextTypes";
import DataTable from "../../../../components/dataTable/DataTable";
import Avatar from "components/avatar/Avatar";
import { GetTicketStubPdf } from "api/rpc/2024-04/facilityAdmin/ticket/stub";
import { GetTicketStubReceipt } from "api/rpc/2024-04/facilityAdmin/ticket/ticket";
import { FormResponseInput, GetFormResponse } from "api/rpc/2024-04/facilityAdmin/facility/form/formResponse";
import useModal from "hooks/modals/useModal";
import Portal from "elements/Portal";
import MessageDisplay from "components/messageDisplay/MessageDisplay";
import { t } from "i18next";
import CashTipModal from "pages/secure/facility/order/CashTipModal";
import TipAllocationSheet from "pages/secure/facility/order/TipAllocationSheet";
import RefundTypeModal from "pages/secure/facility/order/RefundTypeModal";
import { TRefundType } from "api/rpc/2024-04/facilityAdmin/order/refund";
import { TTipAllocationRow } from "components/tip/TipAllocationEditor";
import { GetCartAudits, ICartAudit } from "api/rpc/2024-04/facilityAdmin/cart/cart";
import Divider from "components/divider";
import CartAudits from "../register/registerNew/cartAudits/CartAudits";
import AttachGroupMembershipPopup from "../register/registerNew/AttachGroupMembershipPopup";
import { TOrderMembershipSlot } from "api/rpc/2024-04/facilityAdmin/order/membershipSlots";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface IOrderProps {
  uiActions: IUIActions;
  authStore: IAuthState;
}

interface IOrderState {
  order: IOrder;
  line_items: IOrderLineItem[];
  transactions: IOrderTransaction;
  notes: string;
  uiActions: IUIActions;
  void_reason: string;
}

interface IGiftCardState {
  giftCard: IGiftCard[];
}

interface IChangeCustomerState {
  showChangeCustomer: boolean;
  showNewCustomer: boolean;
  customerQuery: string;
  customerSearching: boolean;
  customerSearchResult: Array<ICustomer>;
  selectedCustomer: ICustomer;
  currentCustomer: any;
}

interface IHouseAccountMoveState {
  show: boolean;
  loading: boolean;
  accounts: HouseAccountType[];
}

interface IEditDetailsState {
  showEditDetails: boolean;
  register_id: number;
  user_id: number;
}

interface IEmailReceiptState {
  email: string;
  showEmailReceipt: boolean;
}

interface IBackdateOrderState {
  selectedDate: Date;
  backdate_time: string;
}

interface ITransactionEditState {
  transactionDate: Date;
  transaction_time: string;
  openTransactionEdit?: boolean;
  transaction: IOrderTransaction;
  transaction_note: string;
  payment_option_id: number;
  allowChangePaymentOption: boolean;
}

interface IFormResponseState {
  id: number;
  form_id: number;
  form: IForm;
  customer_id: number;
  order_id: number;
  cart_id: number;
  response_inputs: Array<FormResponseInput>;
  formattedResponseInputs: IFormattedInputs;
}

interface IFormResponseModalState {
  open: boolean;
  selectedForm: IFormResponseState;
}

interface IFormattedInputs {
  [key: string]: Array<FormResponseInput>;
}

interface IOrderDetailsChanged {
  register_id: boolean;
  user_id: boolean;
  processed_at: boolean;
}

export default function Single(props: IOrderProps) {
  const history = useHistory();
  const { t } = useTranslation();
  const { orderId } = useParams<{ orderId: string }>();
  const { facilityStore } = useAppSelector(store => store);

  const dispatch = useAppDispatch();
  const [orderState, setOrderState] = useState<IOrderState>({
    order: null,
    line_items: [],
    transactions: null,
    notes: "",
    uiActions: null,
    void_reason: "",
  });

  const [, setOrderBeforeState] = useState<IOrderState>({
    order: null,
    line_items: [],
    transactions: null,
    notes: "",
    uiActions: null,
    void_reason: "",
  });

  const [giftCardState, setGiftCardState] = useState<IGiftCardState>({
    giftCard: null,
  });

  const [editDetailsState, setEditDetailsState] = useState<IEditDetailsState>({
    showEditDetails: false,

    register_id: null,
    user_id: null,
  });
  const [editDetailsBeforeState, setEditDetailsBeforeState] = useState<IEditDetailsState>({
    showEditDetails: false,

    register_id: null,
    user_id: null,
  });

  const [changedDetails, setChangedDetails] = useState<IOrderDetailsChanged>({
    register_id: false,
    user_id: false,
    processed_at: false,
  });

  const [emailReceiptState, setEmailReceiptState] = useState<IEmailReceiptState>({
    email: "",
    showEmailReceipt: false,
  });

  const { Option } = Select;

  const { uiActions, authStore } = props;

  const [changePlayerState, setChangePlayerState] = useState<IChangeCustomerState>({
    showChangeCustomer: false,
    showNewCustomer: false,
    customerQuery: "",
    customerSearching: false,
    customerSearchResult: [],
    selectedCustomer: null,
    currentCustomer: null,
  });

  const [houseAccountMoveState, setHouseAccountMoveState] = useState<IHouseAccountMoveState>({
    show: false,
    loading: false,
    accounts: [],
  });

  const [backdateOrderState, setBackdateOrderState] = useState<IBackdateOrderState>({
    selectedDate: new Date(),
    backdate_time: "12:00:00",
  });
  const [changedBackdateOrder, setChangedBackdateOrder] = useState<IBackdateOrderState>({
    selectedDate: new Date(),
    backdate_time: "12:00:00",
  });

  const [transactionState, setTransactionState] = useState<ITransactionEditState>({
    openTransactionEdit: false,
    transactionDate: new Date(),
    transaction_time: "12:00",
    transaction: null,
    transaction_note: "",
    payment_option_id: null,
    allowChangePaymentOption: false,
  });

  const [formResponseState, setFormResponseState] = useState<Array<IFormResponseState>>([]);
  const [formResponseModalState, setFormResponesModalState] = useState<IFormResponseModalState>({
    open: false,
    selectedForm: undefined,
  });

  const [voidPopupVisible, setVoidPopupVisible] = useState(false);
  const [attachMembershipPopup, setAttachMembershipPopup] = useState(false);
  const [paymentVoidWarningVisible, setPaymentVoidWarningVisible] = useState(false);
  const [refundingPayments, setRefundingPayments] = useState(false);
  const [giftCardPopupVisible, setGiftCardPopupVisible] = useState(false);
  const { StripeTerminalRefundSheet, processRefund } = useStripeTerminalPayment();
  const terminalStore = useAppSelector(store => store.terminalStore);
  const [giftCardPresent, setGiftCardPresent] = useState(false);
  const [reinstatePopupVisible, setReinstatePopupVisible] = useState(false);
  const [eRangePresent, setERangePresent] = useState(false);

  const [eRangePopupVisible, setERangePopupVisible] = useState(false);
  const [auditTrail, setAuditTrail] = useState<Array<any>>([]);
  const [cartAudits, setCartAudits] = useState<Array<ICartAudit>>(undefined);

  const { state: auditModal, updateModal: updateAuditModal } = useModal();
  const { state: cashTipModal, updateModal: updateCashTipModal, closeModal: closeCashTipModal } = useModal();
  const [cashTipLoading, setCashTipLoading] = useState(false);
  const {
    state: refundTypeModal,
    updateModal: updateRefundTypeModal,
    closeModal: closeRefundTypeModal,
  } = useModal();
  const {
    state: tipAllocationModal,
    updateModal: updateTipAllocationModal,
    closeModal: closeTipAllocationModal,
  } = useModal<{ tipType: "card" | "cash"; pendingCashTip?: number }>({ tipType: "card" });
  const [tipAllocationLoading, setTipAllocationLoading] = useState(false);

  useEffect(() => {
    void loadOrder();
    void loadFormResponses();
  }, []);

  useEffect(() => {
    if (auditModal.isOpen === true) {
      void getAuditTrail();
    }
  }, [auditModal.isOpen === true]);

  async function loadFormResponses() {
    const formResponseRes = await GetFormResponse({ order_id: Number(orderId) }, true);
    if (formResponseRes.status !== StatusCode.OK) {
      uiActions.showError(t("secure.facility.order.order.055"));
      return;
    }

    if (formResponseRes?.data?.length > 0) {
      const formResponses: Array<IFormResponseState> = [];
      formResponseRes.data?.forEach(response => {
        const formattedResponseInputs = response?.response_inputs?.reduce(
          (formattedInputs: IFormattedInputs, responseInput) => {
            return {
              ...formattedInputs,
              [responseInput.type]: formattedInputs[responseInput.type]
                ? [...formattedInputs[responseInput.type], responseInput]
                : [responseInput],
            };
          },
          {},
        );
        const updatedFormResponse = { ...response, formattedResponseInputs: formattedResponseInputs };
        formResponses.push(updatedFormResponse);
      });
      setFormResponseState(formResponses);
    }
  }

  async function loadGiftCards(order_id: number) {
    const giftCardRes = await GetGiftCard({ order_id: order_id, last_reload_order_id: order_id }, true);
    if (giftCardRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.order.order.071")));
    }

    setGiftCardState({ giftCard: giftCardRes.data });
  }

  async function loadOrder(preservedNotes?: string) {
    const orderRes = await GetOrder({ id: Number(orderId), extended: true }, true);
    if (orderRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.order.order.072")));
      return;
    }

    const order = orderRes.data[0] as IOrder;
    const resolvedNotes = preservedNotes ?? order.notes ?? "";
    const orderWithNotes = { ...order, notes: resolvedNotes };

    const modifiers = order.line_items.filter(lineItem => {
      return lineItem.product_type === "Modifier";
    });
    const lineItems = attachLineItemModifiers(
      order.line_items.filter(lineItem => {
        return lineItem.product_type !== "Modifier";
      }),
      modifiers,
    );
    const giftCards = order.line_items.filter(lineItem => {
      return lineItem.product_type === "Gift Card";
    });
    const orderERangePins = order.line_items.filter(lineItem => {
      return lineItem.product_type === "e-Range";
    });

    if (order.exchanges) {
      order.exchanges = order.exchanges.map(
        exchange => ({
          ...exchange,
          line_items: attachLineItemModifiers(exchange.line_items ?? [], modifiers),
          exchange_line_items: (exchange.exchange_line_items ?? []).map(row => ({
            ...row,
            line_item: row.line_item ? attachLineItemModifiers([row.line_item], modifiers)[0] : row.line_item,
          })),
        }),
      );
    }

    const orderDate = order.processed_at
      ? moment
        .utc(order.processed_at as MomentInput)
        .local()
        .toDate()
      : backdateOrderState.selectedDate;
    const backdateTime = order.processed_at
      ? moment
        .utc(order.processed_at as MomentInput)
        .local()
        .format("HH:mm")
      : backdateOrderState.backdate_time;

    ReactDOM.unstable_batchedUpdates(() => {
      setOrderState(prevState => ({
        ...prevState,
        order: orderWithNotes,
        line_items: lineItems,
        transactions: order.transactions,
        notes: resolvedNotes,
      }));
      setOrderBeforeState(prevState => ({
        ...prevState,
        order: orderWithNotes,
        line_items: lineItems,
        transactions: order.transactions,
        notes: resolvedNotes,
      }));
      setEditDetailsState(prevState => ({
        ...prevState,
        register_id: order.register_id,
        user_id: order.user_id,
      }));
      setEditDetailsBeforeState(prevState => ({
        ...prevState,
        register_id: order.register_id,
        user_id: order.user_id,
      }));
    });

    setBackdateOrderState(prevState => ({
      ...prevState,
      backdate_time: backdateTime,
      selectedDate: orderDate,
    }));
    setChangedBackdateOrder(prevState => ({
      ...prevState,
      backdate_time: backdateTime,
      selectedDate: orderDate,
    }));

    if (order.customer?.email) {
      setEmailReceiptState(prevState => ({ ...prevState, email: order.customer?.email }));
    }

    if (giftCards.length >= 1) {
      void loadGiftCards(order.id);
      setGiftCardPresent(true);
    }
    if (orderERangePins.length >= 1) {
      setERangePresent(true);
    }
  }

  async function updateOrder() {
    const savedNotes = orderState.notes ?? "";

    const orderRes = await PutOrder(
      {
        id: orderState.order?.id,
        notes: savedNotes,
        updated_values: { notes: true },
      },
      true,
    );

    if (orderRes.status !== StatusCode.OK) {
      uiActions?.showError(orderRes.message);
      return;
    }

    uiActions?.showSuccess(orderRes.message || t("Note saved"));

    setOrderState(prevState => ({
      ...prevState,
      notes: savedNotes,
      order: prevState.order ? { ...prevState.order, notes: savedNotes } : prevState.order,
    }));

    void loadOrder(savedNotes);
  }

  async function handleVoidOrder() {
    const putVoidOrder = await PutVoidOrder(
      { order_id: orderState.order?.id, void_note: orderState.void_reason },
      true,
    );

    if (putVoidOrder.status !== StatusCode.OK) {
      props.uiActions.showError(putVoidOrder.message);
    } else {
      props.uiActions.showSuccess(t("secure.facility.order.order.056"));
      history.push("/admin/order/");
    }

    setVoidPopupVisible(false);
  }

  async function handlePrintReceipt() {
    if (orderState.order?.financial_status === "voided" || orderState.order?.financial_status === "cancelled") {
      return;
    }

    const receiptRes = await GetReceipt({ id: Number(orderId) }, true);

    if (receiptRes.status === StatusCode.OK) {
      printDesktopReceipt(orderState.order?.facility_id, String(receiptRes.data));
    } else {
      props.uiActions.showError(receiptRes.message);
    }
  }

  function handleOrderRefund() {
    const status = orderState.order?.financial_status;
    if (
      status === "voided" ||
      status === "cancelled" ||
      status === "unpaid" ||
      status === "refunded"
    ) {
      return;
    }

    updateRefundTypeModal({ isOpen: true });
  }

  function handleRefundTypeSelect(type: TRefundType) {
    closeRefundTypeModal();
    history.push("/admin/order/" + String(orderId) + "/refund?type=" + type);
  }

  function handleVoidClick() {
    const order = orderState.order;
    if (
      orderHasCollectedPayments(
        order?.financial_status,
        order?.transactions,
        order?.balance,
        order?.total_price,
      )
    ) {
      setPaymentVoidWarningVisible(true);
      return;
    }
    setVoidPopupVisible(true);
  }

  async function handleRefundBeforeVoid() {
    const order = orderState.order;
    if (!order?.id || refundingPayments) {
      return;
    }

    setRefundingPayments(true);
    const refundResult = await refundOrderPayments({
      orderId: order.id,
      transactions: order.transactions,
      processInteracRefund: processRefund,
      hasReader: Boolean(terminalStore?.reader),
      note: "Refunded payments before void",
    });

    if (!refundResult.ok) {
      setRefundingPayments(false);
      props.uiActions.showError(refundResult.message || t("Failed to refund payments"));
      return;
    }

    props.uiActions.showSuccess(t("Payments refunded"));
    setPaymentVoidWarningVisible(false);
    setRefundingPayments(false);

    const putVoidOrder = await PutVoidOrder(
      { order_id: order.id, void_note: orderState.void_reason || "Voided after payment refund" },
      true,
    );

    if (putVoidOrder.status !== StatusCode.OK) {
      props.uiActions.showError(putVoidOrder.message || t("Payments were refunded, but voiding the order failed"));
      void loadOrder();
      return;
    }

    props.uiActions.showSuccess(t("secure.facility.order.order.056"));
    history.push("/admin/order/");
  }

  function handleContinueVoidWithoutRefund() {
    setPaymentVoidWarningVisible(false);
    setVoidPopupVisible(true);
  }

  async function createNewCustomer(customerInfo: ICustomerInfoState) {
    const inputError =
      customerInfo.firstName === "" ||
      customerInfo.lastName === "" ||
      (customerInfo.emailAddress === "" && customerInfo.phoneNumber === "");

    if (inputError) {
      //uiActions.showError(t("Please fill all fields"));
    }

    const customerRes = await PostCustomer(
      {
        first_name: customerInfo.firstName,
        last_name: customerInfo.lastName,
        phone: customerInfo.phoneNumber || null,
        email: customerInfo.emailAddress || null,
        send_welcome_email: customerInfo.sendWelcomeEmail,
      },
      true,
    );

    if (customerRes.status !== StatusCode.OK) {
      dispatch(showError(customerErrorMessage(t, String(customerRes?.data?.message))));
      return;
    }
    setChangePlayerState(prevState => ({
      ...prevState,
      showNewCustomer: false,
      selectedCustomer: customerRes.data.data,
    }));
    //uiActions.showSuccess(customerRes.data.message);
  }

  async function getAuditTrail() {
    dispatch(enqueue());
    const [auditRes, cartAuditRes] = await Promise.all([
      GetOrderAudits({ order_id: orderState.order?.id }, false),
      GetCartAudits({ id: orderState?.order?.cart_id }, false),
    ]);
    dispatch(dequeue());
    if (auditRes.status !== StatusCode.OK) {
      dispatch(showError(t("Failed to load audit trail")));
      return;
    }

    if (cartAuditRes?.status !== StatusCode.OK) {
      setCartAudits([]);
      dispatch(showError(errorMessage(cartAuditRes, t("Error getting cart activity"))));
      return;
    }

    ReactDOM.unstable_batchedUpdates(() => {
      setAuditTrail(auditRes.data as Array<any>);
      setCartAudits(cartAuditRes?.data);
    });
  }

  function closeHouseAccountMoveSheet() {
    setHouseAccountMoveState({
      show: false,
      loading: false,
      accounts: [],
    });
  }

  function closeChangePlayer() {
    closeCreateNewCustomer();
    closeHouseAccountMoveSheet();
    setChangePlayerState(prevState => ({
      ...prevState,
      showNewCustomer: false,
      currentCustomer: null,
      showChangeCustomer: false,
      customerQuery: "",
      customerSearchResult: [],
      selectedCustomer: null,
    }));
  }

  function closeCreateNewCustomer() {
    setChangePlayerState(prevState => ({
      ...prevState,
      showNewCustomer: false,
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
    }));
  }

  async function changeCustomer(moveHouseAccountId?: number) {
    const orderCustomerRes = await PutOrder(
      {
        id: orderState.order?.id,
        customer_id: changePlayerState.selectedCustomer.id,
        updated_values: { customer_id: true },
        ...(moveHouseAccountId ? { move_house_account_id: moveHouseAccountId } : {}),
      },
      true,
    );

    if (orderCustomerRes.status !== StatusCode.OK) {
      uiActions.showError(t("Error changing customer"));
      return;
    }

    setChangePlayerState(prevState => ({
      ...prevState,
      currentCustomer: null,
      showChangeCustomer: false,
      customerSearchResult: [],
      customerQuery: "",
      selectedCustomer: null,
    }));
    closeHouseAccountMoveSheet();

    void loadOrder();
  }

  async function handleChangeCustomerConfirm() {
    const selectedCustomer = changePlayerState.selectedCustomer;
    if (!selectedCustomer?.id) {
      return;
    }

    const hasHouseAccountPayments = orderHasActiveHouseAccountPayments(orderState.order?.transactions);
    const customerChanging = selectedCustomer.id !== orderState.order?.customer_id;

    if (hasHouseAccountPayments && customerChanging) {
      setChangePlayerState(prevState => ({
        ...prevState,
        showChangeCustomer: false,
      }));
      setHouseAccountMoveState({
        show: true,
        loading: true,
        accounts: [],
      });

      const accountRes = await GetAccount({ customer_id: selectedCustomer.id, closed: false }, false);
      const accounts =
        accountRes.status === StatusCode.OK && Array.isArray(accountRes.data)
          ? (accountRes.data as HouseAccountType[])
          : [];

      setHouseAccountMoveState({
        show: true,
        loading: false,
        accounts,
      });
      return;
    }

    void changeCustomer();
  }

  function handleHouseAccountMoveConfirm(choice: HouseAccountMoveChoice, selectedAccountId?: number) {
    if (choice === "move" && selectedAccountId) {
      void changeCustomer(selectedAccountId);
      return;
    }

    void changeCustomer();
  }

  function changePlayerHandleCustomerSearch(query: string) {
    setChangePlayerState(prevState => ({ ...prevState, customerQuery: query }));
  }

  function handleChangePlayerSelection(id: number, customer: ICustomer) {
    setChangePlayerState(prevState => ({ ...prevState, selectedCustomer: customer }));
  }

  function emailReceiptEmailChange(e: any) {
    const { value } = e.target;

    setEmailReceiptState(prevState => ({ ...prevState, email: value }));
  }

  function handleShowCustomerChange(customer: any) {
    if (orderState.order?.financial_status === "voided") {
      return;
    }

    setChangePlayerState(prevState => ({
      ...prevState,
      showChangeCustomer: true,
      showNewCustomer: false,
      customerQuery: "",
      customerSearchResult: [],
      currentCustomer: customer,
    }));
  }

  function handleInputChange(event: any) {
    const { id, value } = event.target;
    setOrderState(prevState => ({ ...prevState, [id]: value }));
  }

  function handleNotesCancel() {
    setOrderState(prevState => ({ ...prevState, notes: orderState.order?.notes ?? "" }));
  }

  const notesHaveChanges = (orderState.notes ?? "") !== (orderState.order?.notes ?? "");

  useEffect(() => {
    let mounted = true;
    let timeoutId: NodeJS.Timeout = null;
    if (mounted === true) {
      timeoutId = global.setTimeout(() => {
        void changePlayerSearch(mounted, changePlayerState.customerQuery);
      }, 500);
    }
    return () => {
      mounted = false;
      clearTimeout(timeoutId);
      setChangePlayerState(prevState => ({ ...prevState, playerSearchResult: [] }));
    };
  }, [changePlayerState.customerQuery]);

  async function changePlayerSearch(mounted: boolean, customerSearchQuery: string) {
    try {
      if (customerSearchQuery === "") {
        if (mounted) {
          setChangePlayerState(prevState => ({ ...prevState, customerSearchResult: [] }));
        }
        return;
      } else {
        setChangePlayerState(prevState => ({ ...prevState, customerSearching: true }));
        const customerRes = await GetCustomer({ search: customerSearchQuery }, false);
        if (customerRes.status !== StatusCode.OK) {
          setChangePlayerState(prevState => ({ ...prevState, customerSearching: false, customerSearchResult: [] }));
          return;
        } else if (mounted) {
          setChangePlayerState(prevState => ({
            ...prevState,
            customerSearching: false,
            customerSearchResult: customerRes.data,
          }));

          setEmailReceiptState(prevState => ({ ...prevState, email: customerRes?.data[0]?.email }));
        }
      }
    } catch (error) {
      console.log("err", error);
    }
    return;
  }

  async function handleSaveCashTip(tipAmount: number) {
    if (!orderState.order?.id) {
      return;
    }

    const existingCashAllocations =
      orderState.order.tip_allocations?.filter(allocation => allocation.tip_type === "cash") ?? [];
    const hasMultiCashSplit = existingCashAllocations.length > 1;

    if (hasMultiCashSplit && tipAmount > 0 && authStore.user?.permissions?.orders_edit_tip_allocations) {
      closeCashTipModal();
      updateTipAllocationModal({ isOpen: true, tipType: "cash", pendingCashTip: tipAmount });
      return;
    }

    setCashTipLoading(true);
    const tipRes = await PutOrderTip({ order_id: orderState.order.id, cash_tip: tipAmount }, true);
    setCashTipLoading(false);

    if (tipRes.status !== StatusCode.OK) {
      uiActions.showError(typeof tipRes.data === "string" ? tipRes.data : "Error updating tip");
      return;
    }

    uiActions.showSuccess("Tip updated successfully");
    closeCashTipModal();
    void loadOrder();
  }

  async function handleSaveTipAllocations(allocations: TTipAllocationRow[]) {
    if (!orderState.order?.id) {
      return;
    }

    setTipAllocationLoading(true);

    if (tipAllocationModal.tipType === "cash" && tipAllocationModal.pendingCashTip != null) {
      const tipRes = await PutOrderTip(
        {
          order_id: orderState.order.id,
          cash_tip: tipAllocationModal.pendingCashTip,
          allocations,
        },
        true,
      );
      setTipAllocationLoading(false);

      if (tipRes.status !== StatusCode.OK) {
        uiActions.showError(typeof tipRes.data === "string" ? tipRes.data : "Error updating tip");
        return;
      }

      uiActions.showSuccess("Tip updated successfully");
      closeTipAllocationModal();
      void loadOrder();
      return;
    }

    const res = await PutOrderTipAllocations(
      {
        order_id: orderState.order.id,
        tip_type: tipAllocationModal.tipType,
        allocations,
      },
      true,
    );
    setTipAllocationLoading(false);

    if (res.status !== StatusCode.OK) {
      uiActions.showError(typeof res.data === "string" ? res.data : "Error updating tip allocations");
      return;
    }

    uiActions.showSuccess("Tip allocations updated successfully");
    closeTipAllocationModal();
    void loadOrder();
  }

  function openEditDetailsSheet() {
    setEditDetailsState(prevState => ({ ...prevState, showEditDetails: true }));
  }

  function openEmailReceiptSheet() {
    setEmailReceiptState(prevState => ({ ...prevState, showEmailReceipt: true }));
  }

  function handleEditDetailsChange(value: number, id: string) {
    setEditDetailsState(prevState => ({ ...prevState, [id]: value }));

    if (editDetailsBeforeState[id as keyof IEditDetailsState] !== value) {
      setChangedDetails((prevState: IOrderDetailsChanged) => ({ ...prevState, [id]: true }));
    } else {
      setChangedDetails((prevState: IOrderDetailsChanged) => ({ ...prevState, [id]: false }));
    }
  }

  async function handleUpdateEditDetails() {
    const dateTime =
      moment.utc(backdateOrderState.selectedDate).local().format("YYYY-MM-DD") + " " + backdateOrderState.backdate_time;

    const utcDate = moment(dateTime, "YYYY-MM-DD HH:mm:ss").utc().format("YYYY-MM-DD HH:mm:ss");

    const orderRes = await PutOrder(
      {
        id: orderState.order?.id,
        register_id: editDetailsState.register_id,
        user_id: editDetailsState.user_id,
        processed_at: utcDate,
        updated_values: changedDetails,
      },
      true,
    );

    if (orderRes.status !== StatusCode.OK) {
      uiActions.showError(orderRes.message);
      return;
    }

    setChangedDetails({
      register_id: false,
      user_id: false,
      processed_at: false,
    });

    setEditDetailsState(prevState => ({ ...prevState, showEditDetails: false }));
    uiActions.showSuccess(t("secure.facility.order.order.002"));
    await loadOrder();
  }

  async function handleEmailReceipt() {
    //email receipt

    const params = {
      order_id: orderState.order?.id,
      customer_email: emailReceiptState.email,
    };

    const emailReceiptRes = await EmailReceipt(params, true);
    if (emailReceiptRes?.status !== StatusCode.OK) {
      uiActions.showError(t("secure.facility.order.order.003"));
      return;
    }
    uiActions.showSuccess(t("secure.facility.order.order.004"));
    setEmailReceiptState(prevState => ({ ...prevState, showEmailReceipt: false }));
  }

  async function handleTicketDownload(lineItemId: number, format?: "zebra") {
    const params = {
      order_id: orderState.order?.id,
      order_line_item_id: lineItemId,
      format: format,
    };

    const emailReceiptRes = await GetTicketStubPdf(params, true);

    window.open(emailReceiptRes.data as string, "_blank");

    uiActions.showSuccess(t("secure.facility.order.order.005"));

    return;
  }

  async function handleTicketPrint(lineItemId: number) {
    const params = {
      order_id: orderState.order?.id,
      order_line_item_id: lineItemId,
    };

    const downloadReceiptRes = await GetTicketStubReceipt(params, true);

    if (downloadReceiptRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.product.ticket_stub.026")));

      return;
    }

    window.open().document.write(downloadReceiptRes.data as string);

    return;
  }

  const handleDatePickerChange = (selectedDate: Date) => {
    setBackdateOrderState(prevState => ({ ...prevState, selectedDate: selectedDate }));
    if (
      changedBackdateOrder.selectedDate !== selectedDate ||
      changedBackdateOrder.backdate_time !== backdateOrderState.backdate_time
    ) {
      setChangedDetails((prevState: IOrderDetailsChanged) => ({ ...prevState, processed_at: true }));
    } else {
      setChangedDetails((prevState: IOrderDetailsChanged) => ({ ...prevState, processed_at: false }));
    }
  };

  function backdateOrderChange(id: keyof IBackdateOrderState, value: string) {
    setBackdateOrderState(prev => ({ ...prev, [id]: String(value) }));
    if (changedBackdateOrder[id] !== value || changedBackdateOrder.selectedDate !== backdateOrderState.selectedDate) {
      setChangedDetails((prevState: IOrderDetailsChanged) => ({ ...prevState, processed_at: true }));
    } else {
      setChangedDetails((prevState: IOrderDetailsChanged) => ({ ...prevState, processed_at: false }));
    }
  }

  function orderProcessInfo() {
    let info = " by ";
    if (orderState.order?.sales_channel === "online_store") {
      info = info + orderState.order?.customer?.full_name + " from Online Store";
    } else if (orderState?.order?.sales_channel === "booking_engine") {
      info = info + orderState.order?.customer?.full_name + " from Booking Engine";
    } else {
      info = info + orderState.order?.admin_user?.full_name + " on " + orderState.order?.register?.title;
    }

    return info;
  }

  function handleOpenTransaction(transaction: IOrderTransaction) {
    const paymentOption = facilityStore?.paymentOptions?.find(option => option?.id === transaction?.payment_option_id);

    setTransactionState(prevState => ({
      ...prevState,
      openTransactionEdit: true,
      transactionDate: new Date(moment.utc(transaction?.processed_at).local().format("MMMM DD, YYYY")),
      transaction_time: moment.utc(transaction?.processed_at).local().format("HH:mm"),
      transaction: transaction,
      transaction_note: transaction.note,
      payment_option_id: transaction?.payment_option_id,
      allowChangePaymentOption: paymentOption && paymentOption?.type === "manual" ? true : false,
    }));
  }

  async function handleTransactionEdit() {
    const dateTime =
      moment.utc(transactionState.transactionDate).local().format("YYYY-MM-DD") +
      " " +
      transactionState.transaction_time;

    const processed_at = moment(dateTime, "YYYY-MM-DD HH:mm:ss").utc();
    const processedAtString = processed_at.format("YYYY-MM-DD HH:mm:ss");

    if (processed_at.isAfter(moment.utc())) {
      uiActions.showError(t("secure.facility.order.order.073"));
      return;
    }

    const params = {
      id: transactionState.transaction.id,
      processed_at: processedAtString,
      note: transactionState.transaction_note,
      payment_option_id: transactionState?.allowChangePaymentOption ? transactionState?.payment_option_id : undefined,
    };

    const updateTransactionRes = await PutTransaction(params, true);

    if (updateTransactionRes.status !== StatusCode.OK) {
      return;
    }

    setTransactionState(prevState => ({ ...prevState, openTransactionEdit: false }));
    void loadOrder();
  }

  function handleTransactionDatePickerChange(selectedDate: Date) {
    setTransactionState(prevState => ({ ...prevState, transactionDate: selectedDate }));
  }

  function handleTransactionChange(id: string, value: string) {
    setTransactionState(prevState => ({ ...prevState, [id]: value }));
  }

  // function handleTransactionTimeChange(event: any) {
  //   const { id, value } = event.target;
  //   setTransactionState(prevState => ({ ...prevState, [id]: value }));
  // }

  function setRegisterCart() {
    if (orderState?.order?.cart_id) {
      //Send cart token to register page to continue order
      history.push("/admin/register", {
        params: { cartId: orderState?.order?.cart_id, orderId: orderState?.order?.id },
      });
    }
  }

  async function handleReinstateOrder() {
    const isCancelledOrder = orderState?.order?.financial_status === "cancelled" ? true : false;
    const orderRes = await PutReinstateOrder({ order_id: orderState.order.id }, true);

    if (orderRes.status !== StatusCode.OK) {
      uiActions.showError(t("secure.facility.order.order.057"));
      return;
    }

    props.uiActions.showSuccess(t("secure.facility.order.order.058"));
    if (!isCancelledOrder) {
      history.push("/admin/order/");
    } else {
      void loadOrder();
      setReinstatePopupVisible(false);
    }
  }

  function navigateToGiftCard(code: string) {
    history.push("/admin/giftcards/" + code);
  }

  async function navigateToPrint(event: React.MouseEvent, giftCard: IGiftCard) {
    event.stopPropagation();
    const printGiftCardRes = await PrintGiftCard({ id: giftCard.id }, true);

    if (printGiftCardRes.status === StatusCode.OK) {
      window.open().document.write(printGiftCardRes.data as string);
    } else {
      props.uiActions.showError(printGiftCardRes.message);
    }
  }

  async function downloadGiftCard(event: React.MouseEvent, giftCard: IGiftCard) {
    event.stopPropagation();

    const downloadRes = await DownloadGiftCard({ id: giftCard.id }, true);

    if (downloadRes.status !== StatusCode.OK) {
      props.uiActions.showError(downloadRes.message);
      return;
    }

    window.open(downloadRes.data as string, "_blank");
  }

  const orderSubtitleDate =
    orderState?.order?.processed_at ??
    (orderState?.order?.financial_status === "unpaid" ||
      orderState?.order?.financial_status === "voided" ||
      orderState?.order?.financial_status === "cancelled"
      ? orderState?.order?.created_at
      : null);

  const exchanges = orderState.order?.exchanges ?? [];
  const hasExchanges = exchanges.length > 0;
  const replacementIds = replacementLineItemIds(exchanges);
  const originalLineItems = (orderState.line_items ?? []).filter(item => !replacementIds.has(item.id));
  const originalItemTaxLines = aggregateLineItemTaxLines(originalLineItems);
  const originalTaxLines =
    hasExchanges && originalItemTaxLines.length > 0 ? originalItemTaxLines : orderState.order?.tax_lines;
  const originalSubtotal = hasExchanges
    ? originalLineItems.reduce((sum, item) => sum + lineItemMerchandiseTotal(item), 0)
    : orderState.order?.subtotal_price;
  const originalTotal = hasExchanges
    ? Number(originalSubtotal || 0) +
    (originalTaxLines ?? []).reduce((sum, taxLine) => sum + Number(taxLine.price), 0) +
    Number(orderState.order?.total_tip || 0) +
    Number(orderState.order?.service_fee_total || 0)
    : orderState.order?.total_price;
  const originalTransactions = originalTenders(orderState.order?.transactions, exchanges);

  const isVoidedOrCancelled =
    orderState.order?.financial_status === "voided" || orderState.order?.financial_status === "cancelled";

  const moreOptionsDropdownOptions = isVoidedOrCancelled
    ? [
      { type: "handler" as const, label: t("secure.facility.order.order.011"), handler: openEditDetailsSheet },
      { type: "handler" as const, label: t("secure.facility.order.order.012"), handler: openEmailReceiptSheet },
      { type: "handler" as const, label: t("Reinstate Order"), handler: () => setReinstatePopupVisible(true) },
      {
        type: "handler" as const,
        label: t("Order Audit Trail"),
        handler: () => updateAuditModal({ isOpen: true }),
      },
    ]
    : [
      { type: "handler" as const, label: t("secure.facility.order.order.063"), handler: handleVoidClick },
      { type: "handler" as const, label: t("secure.facility.order.order.011"), handler: openEditDetailsSheet },
      ...(authStore.user?.permissions?.orders_refund_tip &&
        (orderState.order?.financial_status === "paid" ||
          orderState.order?.financial_status === "partially_refunded" ||
          orderState.order?.financial_status === "refunded")
        ? [
          {
            type: "handler" as const,
            label: Number(orderState.order?.cash_tip) > 0 ? t("Adjust cash tip") : t("Add cash tip"),
            handler: () => updateCashTipModal({ isOpen: true }),
          },
        ]
        : []),
      ...(authStore.user?.permissions?.orders_edit_tip_allocations &&
        (orderState.order?.financial_status === "paid" ||
          orderState.order?.financial_status === "partially_refunded" ||
          orderState.order?.financial_status === "refunded")
        ? [
          ...(Number(orderState.order?.total_tip) > 0
            ? [
              {
                type: "handler" as const,
                label: t("Edit tip allocations"),
                handler: () => updateTipAllocationModal({ isOpen: true, tipType: "card" as const }),
              },
            ]
            : []),
          ...(Number(orderState.order?.cash_tip) > 0
            ? [
              {
                type: "handler" as const,
                label: t("Edit cash tip allocations"),
                handler: () => updateTipAllocationModal({ isOpen: true, tipType: "cash" as const }),
              },
            ]
            : []),
        ]
        : []),
      { type: "handler" as const, label: t("secure.facility.order.order.012"), handler: openEmailReceiptSheet },
      ...(giftCardPresent === true
        ? [
          {
            type: "handler" as const,
            label: t("Gift Card Details"),
            handler: () => setGiftCardPopupVisible(true),
          },
        ]
        : []),
      ...(eRangePresent
        ? [
          {
            type: "handler" as const,
            label: t("e-Range Pins Details"),
            handler: () => setERangePopupVisible(true),
          },
        ]
        : []),
      {
        type: "handler" as const,
        label: t("Order Audit Trail"),
        handler: () => updateAuditModal({ isOpen: true }),
      },
      ...(orderState?.order?.financial_status === "paid" || orderState?.order?.financial_status === "partially_refunded" ? 
        [{ 
          type: "handler" as const,
          label: t("Exchange item(s)"), 
          handler: () => history.push(`/admin/order/${orderId}/exchange`) },
        ] : []),
    ];

  return (
    <>
      <Page
        narrow
        splitLayout
        title={t("Order") + " " + orderState.order?.name}
        titleMetadata={
          <Badge
            type={
              orderState.order?.financial_status === "unpaid"
                ? "gray"
                : orderState.order?.financial_status === "paid"
                  ? "success"
                  : orderState.order?.financial_status === "partially_paid"
                    ? "warning"
                    : "gray"
            }
            size="small"
            iconLeft
            icon="circle"
          >
            {valueToString(orderState.order?.financial_status)}
          </Badge>
        }
        subtitle={
          orderSubtitleDate ? (
            <>
              <span>{moment.utc(orderSubtitleDate).local().format("MMMM DD, YYYY")} </span>
              <span>{t("at")} </span>
              <span>{moment.utc(orderSubtitleDate).local().format("h:mm A")}</span>
              <span>{orderProcessInfo()}</span>
            </>
          ) : null
        }
        breadcrumbsNavigateParams={{ orderId: orderId }}
        breadcrumbs={[
          { label: t("Orders"), url: "/admin/order" },
          { label: t("Order details"), url: `/admin/order/${orderId}` },
        ]}
        secondaryActions={[
          {
            type: "text",
            content: t("Receipt"),
            action: handlePrintReceipt,
          },
          ...(authStore.user?.permissions?.orders_refund &&
            ["paid", "partially_paid", "partially_refunded"].includes(orderState.order?.financial_status ?? "")
            ? [
              {
                type: "text" as const,
                content: t("Refund"),
                action: handleOrderRefund,
              },
            ]
            : []),
          ...(((orderState.order?.membership_slots ?? []) as TOrderMembershipSlot[]).some(
            slot => !slot.customer_id && !slot.customer_membership_id,
          )
            ? [
              {
                type: "text" as const,
                content: t("Assign Memberships"),
                action: () => setAttachMembershipPopup(true),
              },
            ]
            : []),
          ...(orderState?.order?.financial_status === "unpaid" ||
            orderState?.order?.financial_status === "partially_paid"
            ? [
              {
                type: "text" as const,
                content: t("secure.facility.order.order.085"),
                action: setRegisterCart,
              },
            ]
            : []),
        ]}
        multipleActionDropdownAction={{
          label: t("More options"),
          icon: <FontAwesomeIcon icon={faChevronDown} className="ml-1 multiple-action-dropdown-trigger-chevron" />,
          dropdownProps: {
            alignment: "right",
            options: moreOptionsDropdownOptions,
          },
        }}
      >
        <Page.Section twoThirds>
            <Card
              title={hasExchanges ? t("Original order") : t("Items")}
            >
              <Card.Section>
                {orderState.order?.line_items &&
                  originalLineItems.map((item: IOrderLineItem) => {
                    return (
                      <Card.SubSection key={item.id}>
                        <OrderLineItemBlock
                          item={item}
                          currency={orderState.order?.currency}
                          discountLines={orderState.order.discount_lines}
                          showReturnedQuantity={hasExchanges}
                          onGiftCardClick={() => setGiftCardPopupVisible(true)}
                          onTicketDownload={handleTicketDownload}
                          onTicketPrint={handleTicketPrint}
                        />
                      </Card.SubSection>
                    );
                  })}
              </Card.Section>
              <Card.Section>
                <div className="order-totals-container">
                  <div className="order-totals">
                    {/* Order subtotal discounts */}
                    {orderState?.order?.discount_lines?.filter(discount => discount?.application === "order")?.map((discount, index) => {
                      if (discount?.loyalty_points_reward_id && discount?.loyalty_points_used != null) {
                        // Loyalty reward order subtotal discount
                        return (
                          <React.Fragment key={index}>
                            <span className="text-lg text-gray-500">[{`-${discount?.loyalty_points_used}${t("pts")}`} <OverlayTrigger placement="auto" overlay={<Tooltip id="leftMenuToolTip">{t("Loyalty reward")}: {discount.title}</Tooltip>}>
                              <FontAwesomeIcon icon={faCircleQuestion} className="ml-1" />
                            </OverlayTrigger>]:</span>
                            <p className="text-lg text-gray-500">
                              <LocaleCurrency currency={orderState.order?.currency} amount={-discount?.amount} />
                            </p>
                          </React.Fragment>
                        );
                      }
                      return (
                        <React.Fragment key={index}>
                           <span className="text-lg text-gray-500">{discount?.title}</span>
                           <p className="text-lg text-gray-500">
                            <LocaleCurrency currency={orderState.order?.currency} amount={-discount?.amount} />
                          </p>
                        </React.Fragment>
                      );
                    })}
                    <span className="text-lg text-semibold">{t("secure.facility.order.order.018")}</span>
                    <p className="text-lg text-semibold">
                      <LocaleCurrency currency={orderState.order?.currency} amount={originalSubtotal} />
                    </p>
                    {(originalTaxLines ?? []).map((tax_line: Record<string, any>, index: number) => {
                      return (
                        <React.Fragment key={index}>
                          <span className="text-lg text-semibold">
                            {tax_line.title}{" "}
                            <span className="text-lg text-gray-500">{displayPercent(tax_line.rate as number, 3)}</span>
                          </span>
                          <p className="text-lg text-semibold">
                            <LocaleCurrency currency={orderState.order?.currency} amount={tax_line.price as number} />
                          </p>
                        </React.Fragment>
                      );
                    })}
                    {Number(orderState.order?.cash_tip) > 0 ? (
                      <>
                        <span className="text-lg text-semibold">
                          {t("Tip")}
                          <span className="text-md text-medium text-gray-500">{t(" (By cash)")}</span>
                        </span>

                        <p className="text-lg text-semibold">
                          <LocaleCurrency currency={orderState.order?.currency} amount={orderState.order?.cash_tip} />
                        </p>
                        {(orderState.order?.tip_allocations?.filter(a => a.tip_type === "cash") ?? []).map(allocation => (
                          <React.Fragment key={`cash-${allocation.user_id}`}>
                            <span className="text-sm text-gray-500 pl-2">
                              {allocation.user?.full_name ||
                                `${allocation.user?.first_name ?? ""} ${allocation.user?.last_name ?? ""}`.trim() ||
                                `Server #${allocation.user_id}`}
                            </span>
                            <p className="text-sm text-gray-500">
                              <LocaleCurrency currency={orderState.order?.currency} amount={allocation.amount} />
                            </p>
                          </React.Fragment>
                        ))}
                      </>
                    ) : null}

                    {Number(orderState.order?.total_tip) > 0 ? (
                      <>
                        <span className="text-lg text-semibold">{t("Tip")}</span>
                        <p className="text-lg text-semibold">
                          <LocaleCurrency
                            currency={orderState.order?.currency}
                            amount={Number(orderState.order?.total_tip || 0)}
                          />
                        </p>
                        {(orderState.order?.tip_allocations?.filter(a => a.tip_type === "card") ?? []).map(allocation => (
                          <React.Fragment key={`card-${allocation.user_id}`}>
                            <span className="text-sm text-gray-500 pl-2">
                              {allocation.user?.full_name ||
                                `${allocation.user?.first_name ?? ""} ${allocation.user?.last_name ?? ""}`.trim() ||
                                `Server #${allocation.user_id}`}
                            </span>
                            <p className="text-sm text-gray-500">
                              <LocaleCurrency currency={orderState.order?.currency} amount={allocation.amount} />
                            </p>
                          </React.Fragment>
                        ))}
                      </>
                    ) : null}

                    {orderState.order?.service_fee_total > 0 ? (
                      <>
                        <span className="text-lg text-semibold">{t("Service Fee")}</span>
                        <p className="text-lg text-semibold">
                          <LocaleCurrency
                            currency={orderState.order?.currency}
                            amount={orderState.order?.service_fee_total}
                          />
                        </p>
                      </>
                    ) : null}

                    <span className="text-lg text-semibold">{t("secure.facility.order.order.020")}</span>
                    <p className="text-lg text-semibold">
                      <LocaleCurrency currency={orderState.order?.currency} amount={originalTotal} />
                    </p>

                    <OrderTenderRows
                      transactions={originalTransactions}
                      currency={orderState.order?.currency}
                      onOpenTransaction={handleOpenTransaction}
                    />
                  </div>
                </div>
              </Card.Section>
            </Card>
            {exchanges.map(exchange => (
              <OrderExchangeCard
                key={exchange.id}
                exchange={exchange}
                currency={orderState.order?.currency}
                discountLines={orderState.order?.discount_lines}
                transactions={orderState.order?.transactions}
                onOpenTransaction={handleOpenTransaction}
                onGiftCardClick={() => setGiftCardPopupVisible(true)}
                onTicketDownload={handleTicketDownload}
                onTicketPrint={handleTicketPrint}
              />
            ))}
          <Card className="order-notes-card" title={t("secure.facility.order.order.021")}>
            <Card.Section noSeparator>
              <Input
                id="notes"
                value={orderState.notes || ""}
                onChange={handleInputChange}
                placeholder={t("secure.facility.order.order.022")}
              />
              <div className="order-notes-card__actions">
                <Button type="secondary" onClick={handleNotesCancel} disabled={!notesHaveChanges}>
                  {t("secure.facility.order.order.066")}
                </Button>
                <Button type="primary" onClick={() => void updateOrder()} disabled={!notesHaveChanges}>
                  {t("Save changes")}
                </Button>
              </div>
            </Card.Section>
          </Card>

          {orderState.order?.customer_notes && (
            <Card title={t("secure.facility.order.order.054")}>
              <Card.Section>
                <div className="text-md">{orderState.order.customer_notes}</div>
              </Card.Section>
            </Card>
          )}

          {orderState.order?.void_note && (
            <Card title={t("secure.facility.order.order.074")}>
              <Card.Section>
                <div className="text-md">{orderState.order.void_note}</div>
              </Card.Section>
            </Card>
          )}
        </Page.Section>
        <Page.Section oneThird>
          <Card
            title={t("secure.facility.order.order.023")}
            titleActions={[
              {
                action: () => handleShowCustomerChange(orderState.order?.customer),
                content: orderState.order?.customer ? t("secure.facility.order.order.024") : t("Add"),
              },
            ]}
          >
            <Card.Section>
              <div>
                {orderState.order?.customer ? (
                  <div>
                    <Avatar size="xxlarge" source={orderState?.order?.customer?.profile_image_source} />
                    <p className="text-lg">{orderState.order?.customer?.full_name}</p>
                    <p className="text-lg">{orderState.order?.customer?.email}</p>
                    <p className="text-lg">{orderState.order?.customer?.phone}</p>
                    <p className="text-lg">{orderState.order?.customer?.customer_type}</p>
                    <div
                      className="cursor-pointer customer-profile"
                      onClick={() =>
                        history.push("/admin/customers/" + String(orderState.order?.customer?.id) + "/profile")
                      }
                    >
                      {t("secure.facility.order.order.075")}{" "}
                      <FontAwesomeIcon style={{ marginLeft: "5px" }} icon={faArrowUpRightFromSquare} size="1x" />
                    </div>
                  </div>
                ) : (
                  <div>
                    <p>{t("secure.facility.order.order.025")}</p>
                  </div>
                )}
              </div>
            </Card.Section>
          </Card>
          {formResponseState?.length > 0 && (
            <Card title={t("secure.facility.order.order.059")}>
              <Card.Section>
                {formResponseState?.map((response, responseIndex) => {
                  return (
                    <div key={responseIndex} className="order-forms-container">
                      <p className="form-title">
                        {response?.form?.title ?? `${t("secure.facility.order.order.061")} ${responseIndex + 1}`}
                      </p>
                      <p
                        className="view-button"
                        onClick={() =>
                          setFormResponesModalState(prevState => ({
                            ...prevState,
                            open: true,
                            selectedForm: response,
                          }))
                        }
                      >
                        {t("secure.facility.order.order.059")}
                      </p>
                    </div>
                  );
                })}
              </Card.Section>
            </Card>
          )}
        </Page.Section>
      </Page>

      <ChangeCustomer
        title={changePlayerState.currentCustomer ? t("secure.facility.order.order.076") : t("Add Customer")}
        currentCustomerTitle={t("secure.facility.order.order.077")}
        newCustomerTitle={t("secure.facility.order.order.078")}
        okText={t("secure.facility.order.order.028")}
        open={changePlayerState.showChangeCustomer}
        changeCustomerState={changePlayerState}
        searching={changePlayerState.customerSearching}
        searchResults={changePlayerState.customerSearchResult}
        newCustomerActive={changePlayerState.showNewCustomer}
        onCancel={closeChangePlayer}
        onOk={() => void handleChangeCustomerConfirm()}
        handleSearchQueryChange={changePlayerHandleCustomerSearch}
        handleCustomerSelection={handleChangePlayerSelection}
        handleRemoveSelectedCustomer={() =>
          setChangePlayerState(prevState => ({
            ...prevState,
            selectedCustomer: null,
            customerSearchResult: [],
            customerQuery: "",
          }))
        }
        handleCreateNewCustomer={customerInfo => void createNewCustomer(customerInfo as ICustomerInfoState)}
        handleCloseCreateNewCustomer={closeCreateNewCustomer}
        handleNewCustomerActive={() => setChangePlayerState(prevState => ({ ...prevState, showNewCustomer: true }))}
      />

      <MoveHouseAccountPaymentsSheet
        open={houseAccountMoveState.show}
        loading={houseAccountMoveState.loading}
        newCustomerName={changePlayerState.selectedCustomer?.full_name ?? ""}
        accounts={houseAccountMoveState.accounts}
        onCancel={closeChangePlayer}
        onConfirm={handleHouseAccountMoveConfirm}
      />

      <Sheet
        title={t("secure.facility.order.order.039")}
        open={editDetailsState.showEditDetails}
        size="medium"
        closable
        onCancel={() =>
          setEditDetailsState(prevState => ({
            ...prevState,
            showEditDetails: false,
            register_id: orderState.order?.register_id,
            user_id: orderState.order?.user_id,
          }))
        }
        overflow
        onOk={handleUpdateEditDetails}
        okText={t("secure.facility.order.order.040")}
      >
        <FormLayout>
          <FormLayout.Group>
            <Select
              label={t("secure.facility.order.order.041")}
              onChange={(value: number) => handleEditDetailsChange(value, "register_id")}
              defaultValue={editDetailsState.register_id ?? null}
              disabled={authStore?.user?.permissions?.orders_edit_register ? false : true}
            >
              {facilityStore?.registers?.map((register, registerIndex) => (
                <Option key={registerIndex} value={register.id} name={register.title}>
                  {register.title}
                </Option>
              ))}
            </Select>

            <>
              <Select
                label={t("secure.facility.order.order.042")}
                onChange={(value: number) => handleEditDetailsChange(value, "user_id")}
                defaultValue={editDetailsState.user_id ?? null}
                disabled={authStore?.user?.permissions?.orders_edit_user ? false : true}
              >
                {facilityStore?.staffAccounts?.map((user, userIndex) => (
                  <Option key={userIndex} value={user.id} name={user.full_name}>
                    {user.full_name}
                  </Option>
                ))}
              </Select>
            </>
          </FormLayout.Group>

          <div className="mt-4">
            <FormLayout.Group>
              <div className="orders-date-picker">
                <p className="date-label">{t("secure.facility.order.order.048")}</p>
                <DatePickerInput
                  months={1}
                  position="left"
                  startingDate={
                    authStore?.user?.permissions?.orders_backdate ? backdateOrderState.selectedDate : undefined
                  }
                  setStartingDate={handleDatePickerChange}
                />

                {!authStore?.user?.permissions?.orders_backdate ? t("secure.facility.order.order.049") : null}
              </div>

              <TimePick
                label={t("secure.facility.order.order.050")}
                align="right"
                value={backdateOrderState.backdate_time}
                onChange={timeString => backdateOrderChange("backdate_time", timeString)}
                disabled={!authStore?.user?.permissions?.orders_backdate}
                size="large"
              />
            </FormLayout.Group>
          </div>
        </FormLayout>
      </Sheet>

      <Sheet
        title={t("secure.facility.order.order.043")}
        open={emailReceiptState.showEmailReceipt}
        size="small"
        closable
        onCancel={() =>
          setEmailReceiptState(prevState => ({
            ...prevState,
            showEmailReceipt: false,
          }))
        }
        onOk={handleEmailReceipt}
        okText={t("secure.facility.order.order.044")}
        okDisabled={emailReceiptState?.email === "" ? true : false}
      >
        <>
          <FormLayout>
            <FormLayout.Group>
              <Input
                label={t("secure.facility.order.order.045")}
                placeholder={t("secure.facility.order.order.046")}
                id="email_receipt"
                value={emailReceiptState.email}
                onChange={emailReceiptEmailChange}
              />
            </FormLayout.Group>
          </FormLayout>
        </>
      </Sheet>

      <Sheet
        title={t("secure.facility.order.order.051")}
        open={transactionState.openTransactionEdit}
        size="small"
        closable
        onCancel={() =>
          setTransactionState(prevState => ({
            ...prevState,
            openTransactionEdit: false,
          }))
        }
        overflow
        onOk={handleTransactionEdit}
        okText={t("secure.facility.order.order.052")}
      // okDisabled={emailReceiptState?.email === "" ? true : false}
      >
        {authStore?.user?.permissions?.orders_backdate ? (
          <>
            <div>
              <p className="date-label">{t("secure.facility.order.order.053")}</p>
              <DatePickerInput
                months={1}
                position="left"
                startingDate={transactionState.transactionDate}
                setStartingDate={handleTransactionDatePickerChange}
              />

              {/* {!authStore?.user?.permissions?.orders_backdate ? "Need Order Backdate Permission" : null} */}
            </div>

            <div className="mt-4">
              <TimePick
                value={transactionState.transaction_time}
                onChange={(timeString?: string) => handleTransactionChange("transaction_time", timeString)}
              //disabled={!authStore?.user?.permissions?.orders_backdate}
              />
            </div>
          </>
        ) : null}

        <div
          style={{
            marginTop: authStore?.user?.permissions?.orders_backdate && "16px",
          }}
        >
          <TextField
            label={t("secure.facility.order.order.079")}
            value={transactionState.transaction_note ?? ""}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
              handleTransactionChange("transaction_note", e.target.value)
            }
            id="transaction_note"
          />
        </div>
        <br />

        {/* Can only change manual payment option to other manual payment options */}
        {transactionState?.allowChangePaymentOption ? (
          <Select
            label={t("Payment Option")}
            onChange={(value: number) => setTransactionState(prevState => ({ ...prevState, payment_option_id: value }))}
            defaultValue={transactionState?.payment_option_id ?? null}
          >
            {facilityStore?.paymentOptions
              ?.filter(paymentOption => paymentOption?.type === "manual")
              ?.map((paymentOption, index) => (
                <Option key={index} value={paymentOption.id}>
                  {paymentOption?.title}
                </Option>
              ))}
          </Select>
        ) : null}
      </Sheet>

      <Sheet
        title={formResponseModalState?.selectedForm?.form?.title ?? t("secure.facility.order.order.062")}
        open={formResponseModalState.open}
        size="small"
        closable
        onCancel={() =>
          setFormResponesModalState(prevState => ({ ...prevState, open: false, selectedForm: undefined }))
        }
        cancelText={t("secure.facility.order.order.061")}
      >
        {formResponseModalState?.selectedForm &&
          Object.keys(formResponseModalState?.selectedForm?.formattedResponseInputs)?.map(key => {
            return (
              <div
                key={key}
                className={classNames("order-response-inputs-container", {
                  "order-response-inputs-checkbox-container": key === "checkbox",
                })}
              >
                {formResponseModalState?.selectedForm?.formattedResponseInputs[key]?.map(
                  (responseInput, inputIndex) => {
                    if (key === "input") {
                      return (
                        <Input key={inputIndex} value={responseInput.value} readOnly label={responseInput.label} />
                      );
                    } else if (key === "select") {
                      return (
                        <Select key={inputIndex} label={responseInput.label} defaultValue={responseInput.value}>
                          <Option value={responseInput.value}>{responseInput.value}</Option>
                        </Select>
                      );
                    } else if (key === "checkbox") {
                      return (
                        <Checkbox
                          key={inputIndex}
                          size="small"
                          label={responseInput.label}
                          checked={!!responseInput.value}
                          readOnly
                        />
                      );
                    }
                  },
                )}
              </div>
            );
          })}
      </Sheet>

      <Sheet
        title={t("secure.facility.order.order.080")}
        open={giftCardPopupVisible}
        closable
        size="small"
        onCancel={() => setGiftCardPopupVisible(false)}
        cancelText={t("secure.facility.order.order.081")}
      >
        {giftCardState?.giftCard?.length === 0 ? (
          <MessageDisplay
            icon="gift"
            title={
              orderState.order?.financial_status === "cancelled" || orderState.order?.financial_status === "voided"
                ? t("No Gift Cards Issued")
                : t("No Gift Cards Found")
            }
            content={
              orderState.order?.financial_status === "cancelled" || orderState.order?.financial_status === "voided"
                ? t(
                  "Gift cards are only issued or reloaded when an order is completed. This order was cancelled or voided before completion, so no gift card was issued or reloaded.",
                )
                : t("No gift cards are linked to this order.")
            }
          />
        ) : (
          <DataTable
            columns={[
              { label: t("secure.facility.order.order.082") },
              { label: t("secure.facility.order.order.083") },
              { label: t("Pin"), width: "10%" },
              { label: "" },
            ]}
          >
            {giftCardState?.giftCard?.map(giftCard => (
              <tr
                key={giftCard.id}
                id={String(giftCard.id)}
                className="clickable"
                onClick={() => navigateToGiftCard(giftCard.code)}
              >
                <td>
                  <div className="flex flex-col">
                    {giftCard.code}
                    <div>
                      {giftCard?.last_reload_order_id != null &&
                        giftCard?.last_reload_order_id !== giftCard?.order_id ? (
                        <Badge size="small" type="success" outline>
                          {t("Reloaded")}
                        </Badge>
                      ) : (
                        <Badge size="small" type="primary" outline>
                          {t("New")}
                        </Badge>
                      )}
                    </div>
                  </div>
                </td>
                <td>
                  <LocaleCurrency amount={giftCard?.balance} currency={giftCard?.currency ?? "CAD"} />
                </td>
                <td>{giftCard.pin}</td>
                <td>
                  <a className="cursor-pointer mr-3" onClick={e => void navigateToPrint(e, giftCard)}>
                    {t("Print")}
                  </a>
                  <a className="cursor-pointer" onClick={e => void downloadGiftCard(e, giftCard)}>
                    {t("Download")}
                  </a>
                </td>
              </tr>
            ))}
          </DataTable>
        )}
      </Sheet>

      {eRangePresent && (
        <ERangePinsModal
          open={eRangePopupVisible}
          eRangeLineItems={orderState.line_items.filter(i => i.product_type === "e-Range")}
          onClose={() => setERangePopupVisible(false)}
        />
      )}

      <AttachGroupMembershipPopup
        open={attachMembershipPopup}
        order={orderState.order}
        slots={((orderState.order?.membership_slots ?? []) as TOrderMembershipSlot[]).filter(
          slot => !slot.customer_id && !slot.customer_membership_id,
        )}
        cartCustomer={orderState.order?.customer}
        onCancel={() => setAttachMembershipPopup(false)}
        onAssigned={() => {
          setAttachMembershipPopup(false);
          void loadOrder();
        }}
      />

      <Popup
        open={paymentVoidWarningVisible}
        type={"warning"}
        title={t("Payments already processed")}
        description={
          getOrderNetCollected(orderState.order?.transactions) > 0
            ? `This order has ${displayCurrency(
              orderState.order?.currency,
              getOrderNetCollected(orderState.order?.transactions),
            )} already collected. Refund payments returns money to the original payment methods (card, gift card, etc.), then voids the order. Hand cash/check back to the customer.`
            : "This order has payments already processed. Refund payments returns money to the original payment methods, then voids the order. Hand cash/check back to the customer."
        }
        okText={t("Refund payments & void")}
        cancelText={t("Cancel")}
        backDropCancel={!refundingPayments}
        loading={refundingPayments}
        okDisabled={refundingPayments}
        cancelDisabled={refundingPayments}
        onOk={() => handleRefundBeforeVoid()}
        onCancel={() => {
          if (!refundingPayments) {
            setPaymentVoidWarningVisible(false);
          }
        }}
      >
        <div style={{ marginTop: "12px" }}>
          <Button
            type="error-outline"
            block
            disabled={refundingPayments}
            onClick={handleContinueVoidWithoutRefund}
          >
            {t("Void without refunding")}
          </Button>
        </div>
      </Popup>

      <Popup
        open={voidPopupVisible}
        type={"warning"}
        title={t("secure.facility.order.order.063")}
        description={
          "Voiding removes this order and its payments from sales reports as if it never existed. This does not create refund line items. Card or cash still held outside Tee On must be handled separately."
        }
        okText={t("secure.facility.order.order.065")}
        cancelText={t("secure.facility.order.order.066")}
        backDropCancel
        onOk={() => handleVoidOrder()}
        okDisabled={facilityStore.teeSheetSettings?.orders_void_with_note ? orderState.void_reason === "" : false}
        onCancel={() => setVoidPopupVisible(false)}
      >
        {facilityStore.teeSheetSettings?.orders_void_with_note ? (
          <Input
            id="void_reason"
            value={orderState.void_reason || ""}
            onChange={handleInputChange}
            placeholder={t("secure.facility.order.order.084")}
          />
        ) : null}
      </Popup>

      <Popup
        open={reinstatePopupVisible}
        type={"warning"}
        title={t("secure.facility.order.order.067")}
        description={t("secure.facility.order.order.068")}
        okText={t("secure.facility.order.order.069")}
        cancelText={t("secure.facility.order.order.070")}
        backDropCancel
        onOk={() => handleReinstateOrder()}
        onCancel={() => setReinstatePopupVisible(false)}
      />

      <Portal isMounted={auditModal.isOpen}>
        <Sheet
          open={auditModal.isOpen}
          size="small"
          title={t("Order Audit Trail")}
          hideCancelButton
          closable
          onCancel={() => updateAuditModal({ isOpen: false })}
        >
          <div>
            {auditTrail.length > 0 ? (
              <ul>
                {t("Order audit")}
                {auditTrail.map((audit, index) => (
                  <>
                    <li key={audit.id}>
                      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <div className="audit-trail-note-container">
                          <div style={{ justifySelf: "center" }}>
                            <div className={`audit-trail-circle-${audit.action}`}>
                              {audit.action === "modified" ? (
                                <FontAwesomeIcon
                                  icon={faCircleExclamation}
                                  className={`audit-trail-circle-${audit.action}-icon`}
                                />
                              ) : audit.action === "voided" || audit.action === "cancelled" ? (
                                <FontAwesomeIcon icon={faBan} className={`audit-trail-circle-${audit.action}-icon`} />
                              ) : audit.action === "refund" ? (
                                <FontAwesomeIcon
                                  icon={faRotateLeft}
                                  className={`audit-trail-circle-${audit.action}-icon`}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faCircleCheckRegular}
                                  className={`audit-trail-circle-${audit.action}-icon`}
                                />
                              )}
                            </div>
                            {index < auditTrail.length - 1 ? <div className="bm-audit-trail-line"></div> : null}
                          </div>

                          <div style={{ marginLeft: "18px" }}>
                            <div className="audit-trail-title">{audit.title}</div>
                            <div className="audit-trail-note">{audit.description}</div>
                          </div>

                          {/* <div style={{ marginLeft: "18px" }}>
                            {audit.description.split(" ")[1] === "Date" ? (
                              <div className="audit-trail-note">
                                {t('Order Date updated to ')}
                                {moment
                                  .utc(audit.new_value as MomentInput)
                                  .local()
                                  .format("MMMM Do YYYY, h:mm a")}{" "}
                                by {audit.description.split("by ")[1]}
                              </div>
                            ) : (
                            )}
                          </div> */}
                        </div>
                        <div className="audit-trail-date">
                          <div>{moment(audit.created_at as MomentInput).format("MMMM Do YYYY, h:mm a ")}</div>
                          <div>{audit.user_id?.full_name}</div>
                        </div>
                      </div>
                    </li>
                  </>
                ))}
              </ul>
            ) : (
              <MessageDisplay
                icon="search"
                title={t("No Audit Trail Found")}
                content={t("Your order does not have any audit trail records.")}
              />
            )}
            {cartAudits && cartAudits?.length > 0 ? (
              <>
                <Divider small />
                {t("Cart audit")}
                <br />
                <br />
                <CartAudits audits={cartAudits} />
              </>
            ) : null}
          </div>
        </Sheet>
      </Portal>

      <StripeTerminalRefundSheet />

      <CashTipModal
        open={cashTipModal.isOpen}
        currentTip={Number(orderState.order?.cash_tip) || 0}
        currency={orderState.order?.currency}
        okLoading={cashTipLoading}
        onCancel={closeCashTipModal}
        onOk={tipAmount => void handleSaveCashTip(tipAmount)}
      />

      <RefundTypeModal
        open={refundTypeModal.isOpen}
        onCancel={closeRefundTypeModal}
        onSelect={handleRefundTypeSelect}
      />

      <TipAllocationSheet
        open={tipAllocationModal.isOpen}
        tipType={tipAllocationModal.tipType}
        tipTotal={
          tipAllocationModal.tipType === "cash"
            ? Number(tipAllocationModal.pendingCashTip ?? orderState.order?.cash_tip ?? 0)
            : Number(orderState.order?.total_tip ?? 0)
        }
        initialAllocations={(orderState.order?.tip_allocations ?? [])
          .filter(allocation => allocation.tip_type === tipAllocationModal.tipType)
          .map(allocation => ({ user_id: allocation.user_id, amount: Number(allocation.amount) }))}
        currency={orderState.order?.currency}
        okLoading={tipAllocationLoading}
        onCancel={closeTipAllocationModal}
        onOk={allocations => void handleSaveTipAllocations(allocations)}
      />
    </>
  );
}

function ERangePinsModal({
  open,
  eRangeLineItems,
  onClose,
}: {
  open: boolean;
  eRangeLineItems: IOrderLineItem[];
  onClose: () => void;
}) {
  const { facilityStore } = useAppSelector(store => store);
  const dispatch = useAppDispatch();
  const [eRangePins, setERangePins] = useState<IERangePin[]>([]);

  const findOrderLine = useCallback((id: number) => eRangeLineItems.find(i => i.id === id), [eRangeLineItems]);

  async function printPin(pin: IERangePin) {
    const printRes = await PrintERangePins({ order_id: pin.order_id, e_range_pin_id: pin.id }, true);
    printDesktopReceipt(facilityStore.facility?.id, printRes.data.toString() as string);
  }

  async function printAllPins() {
    const pin = eRangePins[0] ?? null;
    if (pin === null) {
      return;
    }

    const printRes = await PrintERangePins({ order_id: pin.order_id }, true);
    printDesktopReceipt(facilityStore.facility?.id, printRes.data.toString() as string);
  }

  async function regeneratePin(pin: IERangePin) {
    const regenRes = await PutERangePinRegenerate({ e_range_pin_id: pin.id });
    if (regenRes.status !== StatusCode.OK) {
      dispatch(showError(t("Failed to regenerate pin")));
      return;
    }

    void loadERangePins(eRangeLineItems[0]?.order_id ?? 0);
  }

  async function loadERangePins(order_id: number) {
    const pins = await GetERangePins({ order_id: order_id });
    if (pins.status !== StatusCode.OK) {
      dispatch(showError(t("Failed to load e-Range Pins")));
    }

    setERangePins(pins.data);
  }

  useEffect(() => {
    void loadERangePins(eRangeLineItems[0]?.order_id ?? 0);
  }, []);

  return (
    <Portal isMounted={open}>
      <Sheet
        title={t("Order e-Range Pins")}
        open={open}
        closable
        size="small"
        onCancel={onClose}
        onSecondary={() => printAllPins()}
        secondaryText={t("Print All")}
      >
        <DataTable columns={[{ label: "Product" }, { label: "Pin" }, { label: "" }]}>
          {eRangePins?.map(pin => {
            const lineItem = findOrderLine(pin.order_line_item_id);
            return (
              <tr key={pin.id} id={String(pin.id)} className="clickable">
                <td>
                  {lineItem?.product_title} - {lineItem.variant_title}
                </td>
                <td>{pin.pin}</td>
                <td>
                  {Number(pin.pin) <= 0 ? (
                    <Button type="error-outline" onClick={() => void regeneratePin(pin)}>
                      {t("Regenerate")}
                    </Button>
                  ) : (
                    <Button onClick={() => void printPin(pin)}>{t("Print")}</Button>
                  )}
                </td>
              </tr>
            );
          })}
        </DataTable>
      </Sheet>
    </Portal>
  );
}
